import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';

import App from './App.vue'
import HomePage from './components/top_level/HomePage.vue'
import RoversPage from './components/top_level/RoversPage.vue'
import RoverPage from './components/top_level/RoverPage.vue'
import AddRoverPage from './components/top_level/AddRoverPage.vue'
import RoverChangeTariffPage from './components/top_level/RoverChangeTariffPage.vue'
import PaymentsPage from './components/top_level/PaymentsPage.vue'
import PaymentPage from './components/top_level/PaymentPage.vue'
import StatsPage from './components/top_level/StatsPage.vue'
import AdminStatsPage from './components/top_level/AdminStatsPage.vue'
import EventsPage from './components/top_level/EventsPage.vue'
import LoginPage from './components/top_level/LoginPage.vue'
import RegistrationPage from './components/top_level/RegistrationPage'
import ActivationRequiredPage from './components/top_level/ActivationRequiredPage'
import ActivationProcessPage from './components/top_level/ActivationProcessPage'
import TariffsPage from './components/top_level/TariffsPage.vue';
import AccountPage from './components/top_level/AccountPage.vue'

import { useUserStore } from '@/stores/user';
import i18n from '@/i18n';

import './assets/global.less';

const app = createApp(App);

const DEFAULT_TITLE = 'Mixer UI';
const routes = [
	{
		path: '/',
		name: 'home',
		component: HomePage,
	},
	{
		path: '/rovers',
		name: 'rovers',
		component: RoversPage,
	},
	{
		path: '/rover/:roverId',
		name: 'rover-page',
		component: RoverPage,
	},
	{
		path: '/add-rover',
		name: 'add-rover',
		component: AddRoverPage,
	},
	{
		path: '/rover/change-tariff/:roverId',
		name: 'rover-change-tariff',
		component: RoverChangeTariffPage,
	},
	{
		path: '/payments',
		name: 'payments',
		component: PaymentsPage,
	},
	{
		path: '/payment/:uuid',
		name: 'payment-page',
		component: PaymentPage,
	},
	{
		path: '/stats',
		name: 'stats',
		component: StatsPage,
	},
	{
		path: '/admin-stats',
		name: 'admin-stats',
		component: AdminStatsPage,
	},
	{
		path: '/events',
		name: 'events',
		component: EventsPage,
	},
	{
		path: '/login',
		name: 'login',
		component: LoginPage,
	},
	{
		path: '/registration',
		name: 'registration',
		component: RegistrationPage,
	},
	{
		path: '/activation-required',
		name: 'activation-required',
		component: ActivationRequiredPage,
	},
	{
		path: '/user-activation/:uid/:token',
		name: 'activation-process',
		component: ActivationProcessPage,
	},
	{
		path: '/tariffs',
		name: 'tariffs',
		component: TariffsPage,
	},
	{
		path: '/account',
		name: 'account',
		component: AccountPage,
	},
]

axios.defaults.baseURL = window.BASE_URL + '/api/v1/';

const pinia = createPinia();

const router = createRouter({
	history: createWebHistory(),
	routes,
});
router.beforeEach(to => {
	const userStore = useUserStore();
	if (!userStore.isAuthenticated && !['login', 'registration', 'home', 'tariffs'].includes(to.name)) {
		return { name: 'login' };
	}
	if (userStore.isAuthenticated && ['home'].includes(to.name)) {
		return { name: userStore.homePage };
	}
});
router.afterEach(to => {
	nextTick(() => {
		document.title = i18n.global.t('title.' + to.name) + ' | ' + DEFAULT_TITLE;
	});
});

app.use(router, axios);
app.use(i18n);
app.use(pinia);
app.mount('#app');
